import {useCountryLang} from "./useCountryLang";
import {useQuery} from '@tanstack/react-query';
import {request} from "../shared/httpInterceptor";
import {useAtom} from "jotai";
import {nextSessionAtom} from "../store/sessionAtom";

export const fetchCountryList = async (countryLang: string | null, session: any, host?: string) => {
  const res = await request({
    url: `/${countryLang}/country/list`,
    method: 'get',
    session: session,
    host: host
  });
  return res.data;
}

export const useCountryList = () => {
  const countryLang = useCountryLang()
  const [sessionAtom] = useAtom(nextSessionAtom)
  const {session, status} = sessionAtom;
  return useQuery(["country-options", countryLang], () => fetchCountryList(countryLang, session), {
    enabled: countryLang!=null
  })
}

export const toCountryArray = (countryMap:any):Array<any> => {

  const countryKeys = Object.keys(countryMap);
  const countryArray: Array<any> = [];

  countryKeys.forEach(k => {
    countryArray.push({
      value: k,
      label: countryMap[k]
    });
  });

  return countryArray;
}